<template>
	<div v-show="mysteryBoxProduct">
		<v-dialog
			v-model="mysteryBoxProduct"
			content-class="mystery-box-dialog dialog-over-whole-page popup-wrapper"
			persistent
		>
			<template v-if="globalSelectedShop.shopOptions.enableMysteryBoxRandomActOfKindness">
			<v-card class="random-act-of-kindness" :class="{'random-act-of-kindness-mobile': isMobile}">
				<img :src="getMiscImageUrl('raok-product.svg')" :alt="mysteryBoxProduct.name" class="mystery-box-product-image"/>
				<img :src="getMiscImageUrl(isMobile ? 'random-act-of-kindness-mobile.svg' : 'random-act-of-kindness.png')" :alt="mysteryBoxProduct.name" class="mystery-box-overlay-image" />
				<div class="raoc-overlay">
					<div class="raoc-header">
						<div class="raoc-header-title">{{ $t('utilityComponents.randomActOfKindness.letsGo') }}</div>
						<div class="raoc-product">{{ $t('utilityComponents.randomActOfKindness.product') }}</div>
						<div class="gratis">{{ $t('utilityComponents.randomActOfKindness.gratis') }}</div>
					</div>
					<div class="raoc-footer">
						<div class="raoc-delicious">{{ $t('utilityComponents.randomActOfKindness.delicious') }}</div>
						<div class="raoc-buttons">
							<v-btn class="btn-transparent" @click="closeModal">
								{{ $t('utilityComponents.randomActOfKindness.noThanks') }}
							</v-btn>
							<v-btn class="btn-secondary" @click="addToBasketMysteryProduct(mysteryBoxProduct)">
								{{ $t('utilityComponents.randomActOfKindness.yesThanks') }}
							</v-btn>
						</div>
						<div class="raoc-description">{{ $t('utilityComponents.randomActOfKindness.description') }}</div>
					</div>
				</div>
			</v-card>
			</template>
			<template v-else>
				<v-card class="mystery-box-product-gif" v-if="!showMysteryBoxProduct" @click="showMysteryBoxProduct = true">
					<v-btn
						v-if="isMobile"
						icon
						class="close-btn"
						@click="closeModal"
					>
						<img class="close-image" src="../../../static/tid100/images/icons/x-close.svg"/>
					</v-btn>
					<v-card-title>
						<div>
							<div class="mystery-box-title">{{ $t('utilityComponents.mysteryBox.title') }}</div>
							<div class="mystery-box-subtitle">{{ $t('utilityComponents.mysteryBox.subtitle') }}</div>
						</div>
					</v-card-title>
					<div v-if="isMobile" class="mystery-box-subtitle-mobile">{{ $t('utilityComponents.mysteryBox.text') }}</div>
					<v-card-text>
						<v-img :src="getMiscImageUrl('MysteryBox.gif')"/>
					</v-card-text>
					<div v-if="!isMobile" class="mystery-box-subtitle">{{ $t('utilityComponents.mysteryBox.text') }}</div>
				</v-card>
				<v-card v-if="showMysteryBoxProduct" class="mystery-box-product-body">
					<v-btn
						v-if="isMobile"
						icon
						class="close-btn"
						@click="closeModal"
					>
						<img class="close-image" src="../../../static/tid100/images/icons/x-close.svg"/>
					</v-btn>
					<v-card-title>
						<div>
							<div class="mystery-box-title">{{ $t('utilityComponents.mysteryBox.unlockedPrizeTitle') }}</div>
							<div class="mystery-box-subtitle">{{ $t('utilityComponents.mysteryBox.unlockedPrizeText') }}</div>
						</div>
					</v-card-title>
					<v-card-text>
						<div class="popup-wrapper">
							<div class="mystery-box-product" @click="addToBasketMysteryProduct(mysteryBoxProduct)">
								<div class="product-price-before">{{ formatPriceZero(mysteryBoxProduct.price) }}</div>
								<div class="product-price">{{ formatPriceZero(getDiscountedProductPrice) }}</div>
								<img :src="getProductImage(mysteryBoxProduct)" :alt="mysteryBoxProduct.name" class="mystery-box-image" />
								<div class="product-name">{{ mysteryBoxProduct.name }}</div>
								<div class="label bow bow-left">
									{{ $t('utilityComponents.mysteryBox.specialPrice') }}
								</div>
							</div>
						</div>
					</v-card-text>
					<v-btn class="add-btn add full-width" @click="closeModal">
						{{ $t('utilityComponents.mysteryBox.checkoutButton') }}
					</v-btn>
				</v-card>
				<div class="close-btn" @click="closeModal"></div>
			</template>
		</v-dialog>
	</div>
</template>
<script>
import * as Util from "../../libraries/utils";
import appConfig, {channelEnum} from "../../appconfig";
import ProductSelection from "../../domains2/orders/ProductSelection";
import * as actions from "../../store/mutation-types";
import {voucherValidationHelper} from "../../helper/VoucherValidationHelper";
import {mapGetters} from "vuex";
import {formatPriceZero} from "../../domains2/libraries/Utils";
import {getMiscImageUrl} from "../../libraries/utils";
import * as mutationTypes from "../../store/mutation-types";
import MysteryBoxProvider, {MYSTERY_BOX_VOUCHER_STATUSES} from "../../providers/MysteryBoxProvider";
import { getProductSpecificDiscount } from "../../domains2/priceRules/priceRulesHelpers";
export default {
	name: "MysteryBox",
	props: [
		"mysteryBoxProductId",
		"applicableMysteryBoxPriceRule",
		"closeModal"
	],
	data() {
		return {
			showMysteryBoxProduct: false
		};
	},
	computed: {
		...mapGetters([
			"tenantSettings",
			"productCatalog",
			"cartProducts",
			"voucherVirtualOrderId",
			"globalSelectedShop"
		]),
		getDiscountedProductPrice() {
			const price = this.mysteryBoxProduct.price - getProductSpecificDiscount({price: this.mysteryBoxProduct.price, discount: this.applicableMysteryBoxPriceRule});
			return price > 0 ? price : 0;
		},
		mysteryBoxProduct() {
			return this.productCatalog.getProduct(this.mysteryBoxProductId);
		},
		isMobile() {
			return appConfig.channelAlias() === channelEnum.mobileBrowser || appConfig.channelAlias() === channelEnum.mobileApp;
		}
	},
	mounted() {
		if(!this.globalSelectedShop.shopOptions.enableMysteryBoxRandomActOfKindness) {
			setTimeout(() => {
				this.showMysteryBoxProduct = true;
			}, 5000);
		}
	},
	methods: {
		getMiscImageUrl,
		formatPriceZero,
		getProductImage(product) {
			return Util.getBackImages(product, this.channel === "kiosk").slice(0, 1);
		},
		async addToBasketMysteryProduct(product) {
			if(!this.cartProducts.length) {
				this.$store.commit(mutationTypes.SET_MYSTERY_BOX_MODAL_STATE);
				this.closeModal();
				return;
			}
			const psOptions = {
				expiration: {
					tenantSettings: this.tenantSettings.productSelectionExpiration,
					tenantConfig: appConfig.tenantConfig.productSelectionExpiration
				}
			};
			const productSelection = ProductSelection.createFromProduct(product, psOptions);
			productSelection.quantity = productSelection.quantity || 1;
			productSelection.mysteryBoxAppliedVoucherId = this.applicableMysteryBoxPriceRule.voucherPattern[0];
			await this.$store.dispatch(actions.ADD_PRODUCT_SELECTION_TO_CART, productSelection);
			await voucherValidationHelper(
				this,
				this.applicableMysteryBoxPriceRule.voucherPattern[0],
				true,
				this.getMysteryBoxPriceRuleLabel
			);
			this.$store.commit(mutationTypes.SET_MYSTERY_BOX_MODAL_STATE);
			this.$emit("mysteryBoxProductAdded");
			if(this.voucherVirtualOrderId) {
				await MysteryBoxProvider.changeStatusMysteryBox(this.voucherVirtualOrderId, MYSTERY_BOX_VOUCHER_STATUSES.CONFIRM);
			}
		}
	}
};
</script>
<style scoped lang="scss">
/deep/ .mystery-box-dialog {
	position: relative;
	.v-card {
		width: 900px;
		height: 658px;
		background-color: #000000 !important;
		color: #FFFFFF;
		padding: 20px;
		.mystery-box-title {
			font-size: 28px;
			font-weight: bold;
			text-align: center;
		}
		.mystery-box-subtitle {
			font-size: 24px;
			text-align: center;
		}
		.v-card__title {
			justify-content: center;
			padding-top: 30px;
			padding-bottom: 0;
		}
		.v-card__text {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 570px;
			margin: auto;
			padding-top: 0;
			padding-bottom: 40px;
			.v-image__image {
				background-size: auto;
			}
		}
		> .mystery-box-subtitle {
			padding-bottom: 30px;
		}
		&.mystery-box-product-body {
			.v-card__text {
				padding-bottom: 0;
			}
			.mystery-box-product {
				position: relative;
				width: 400px;
				height: 400px;
				padding: 40px;
				img {
					width: 100%;
				}
				.product-price-before {
					position: absolute;
					top: 57px;
					right: 50px;
					font-size: 14px;
					font-weight: bold;
					color: #8E8E8E;
					text-decoration: line-through;
				}
				.product-price {
					position: absolute;
					top: 74px;
					right: 50px;
					font-size: 14px;
					font-weight: bold;
					color: #ffd800;
				}
				.product-name {
					position: absolute;
					bottom: 60px;
					right: 50px;
					text-align: center;
					max-width: 300px;
					width: 100%;
					font-size: 16px;
					font-weight: bold;
					line-height: 1;
				}
				.mystery-box-image {
					border: 2px solid #ffd800;
					box-shadow: 0 0 20px 0 #ffd800;
				}
				.bow.bow-left {
					position: absolute;
					color: #000;
					background-color: #ffd800;
					font-weight: 700;
					font-size: 15px;
					text-transform: uppercase;
					top: 55px;
					left: 42px !important;
					padding: 13px 30px 12px;
					line-height: 1;
				}
			}
			.add-btn {
				height: 60px;
				font-size: 22px;
				font-weight: bold;
				border: 2px solid #fff;
				background-color: transparent;
				color: #FFFFFF;
				display: flex;
				margin: auto;
				max-width: 350px;
			}
		}
	}
	.random-act-of-kindness {
		padding: 0;
		.mystery-box-product-image {
			width: 100%;
			height: 100%;
		}
		.mystery-box-overlay-image {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
		}
		.raoc-overlay {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
			.raoc-header {
				text-align: center;
				line-height: 1;
				.raoc-header-title {
					font-weight: bold;
					font-size: 54px;
					padding-top: 50px;
					text-transform: uppercase;
				}
				.raoc-product {
					font-size: 36px;
					padding-top: 15px;
				}
				.gratis {
					font-size: 54px;
					font-weight: bold;
					color: #FFD800;
					padding-top: 15px;
					text-transform: uppercase;
				}
			}
			.raoc-footer {
				.raoc-delicious {
					font-size: 28px;
					line-height: 30px;
					text-align: center;
					padding-bottom: 17px;
				}
				.raoc-buttons {
					padding-bottom: 20px;
				}
				.btn-transparent {
					width: 344px;
					height: 60px;
					padding: 0 25px;
					text-transform: none;
					.v-btn__content {
						font-size: 18px;
						line-height: 22px;
						height: 60px;
						white-space: normal;
						flex: 0 1 auto;
					}
				}
				.btn-secondary {
					width: 344px;
					height: 60px;
					text-transform: uppercase;
				}
				.raoc-description {
					font-size: 14px;
					line-height: 18px;
					text-align: center;
					padding-bottom: 30px;
				}
			}
		}
		&.random-act-of-kindness-mobile {
			padding: 0;
			overflow: hidden;
			.raoc-header {
				padding: 5px;
				.raoc-header-title {
					font-size: 42px;
					padding-top: 120px;
				}
				.raoc-product {
					font-size: 26px;
				}
				.gratis {
					font-size: 42px;
				}
			}
			.raoc-footer {
				.raoc-delicious {
					font-size: 22px;
					line-height: 22px;
				}
				.raoc-buttons {
					display: flex;
					flex-direction: column-reverse;
					.v-btn {
						margin: 20px 16px 0;
						width: calc(100% - 32px);
						&.btn-transparent {
							background-color: transparent;
							border: 2px solid #ffffff;
							color: #ffffff;
							.v-btn__content {
								font-weight: bold;
							}
						}
						&.btn-secondary {
							background-color: #218C74;;
							border: 2px solid #218C74;;
							color: #ffffff;
							.v-btn__content {
								font-size: 22px;
								font-weight: bold;
								text-transform: uppercase;
							}
						}
					}
				}
				.raoc-description {
					text-wrap: balance;
				}
			}
			.mystery-box-product-image {
				transform: scale(1.5);
			}
			.mystery-box-overlay-image {
				transform: scale(1.1);
				height: auto;
			}
		}
	}
}
@media screen and (max-width: 450px) {
	/deep/ .mystery-box-dialog {
		max-height: 100%;
		width: 100%;
		.v-card, .mystery-box-product-body {
			width: 100%;
			height: 100vh;
		}
		.v-card {
			padding: 5px;
			.mystery-box-title, .mystery-box-subtitle {
				font-size: 18px;
			}
		}
	}
	.v-card__text {
		width: 100% !important;
		padding: 0;
	}
	.mystery-box-subtitle-mobile {
		font-size: 14px;
		text-align: center;
		padding: 30px 0;
	}
	.v-dialog__content.v-dialog__content--active:has(.mystery-box-dialog) {
		z-index: 9999 !important;
	}
	.close-btn {
		display: flex;
		margin-left: auto;
	}
	.v-card.mystery-box-product-body {
		.mystery-box-subtitle {
			font-size: 14px !important;
			padding-top: 30px;
		}
		.v-btn.add-btn {
			height: 50px;
			position: absolute;
			bottom: 0;
			width: calc(100% - 42px);
			margin: 16px;
			max-width: none;
		}
	}
	.v-card__text /deep/ .v-image {
		height: 400px;
	}
}

</style>
